export default {
    variables: [
      {
        name: "$NAME",
        show: true,
        label: "Primeiro nome do cliente 12 caracteres",
        length: 12,
      },
      {
        name: "$DOC_START",
        show: true,
        label: "Três digitos CPF, ex: 111.***.***-**",
        length: 14,
      },
      {
        name: "$BUSINESS_NAME",
        show: true,
        label: "Primeiros nome da empresa até 18 caracteres",
        length: 18,
      },
      {
        name: "$CREDITOR",
        show: true,
        label: "Nome do credor 16 caracteres",
        length: 16,
      },
      {
        name: "$CREDITOR_PROFILE_NAME",
        show: true,
        label: "Nome do credor (securitizadoras) 16 caracteres",
        length: 16,
      },
      {
        name: "$DEAL_PROFILE_NAME",
        show: true,
        label: "Nome do cedente (securitizadoras) 16 caracteres",
        length: 16,
      },
      {
        name: "$INCASH_PRINCIPAL_DISCOUNT",
        show: false,
        label: "Desconto principal à vista",
        length: 3,
      },
      {
        name: "$INCASH_DEBIT_PRINCIPAL_DISCOUNT",
        show: false,
        label: "Desconto principal à vista (déb. automático)",
        length: 3,
      },
      {
        name: "$INCASH_INTEREST_DISCOUNT",
        show: false,
        label: "Desconto principal à vista nos juros",
        length: 3,
      },
      {
        name: "$INCASH_DEBIT_INTEREST_DISCOUNT",
        show: false,
        label: "Desconto principal à vista nos juros (déb. automático)",
        length: 3,
      },
      {
        name: "$MAX_INSTALLMENTS",
        show: true,
        label: "Número máximo de parcelas 3 caracteres",
        length: 3,
      },
      {
        name: "$MAX_DISCOUNT",
        show: true,
        label: "Máximo de desconto 3 caracteres",
        length: 3,
      },
      {
        name: "$PROPOSAL_DISCOUNT",
        show: true,
        label: "Porcentagem de desconto 3 caracteres",
        length: 3,
      },
      {
        name: "$PROPOSAL",
        show: true,
        label: "Valor á vista 10 caracteres",
        length: 10,
      },
      {
        name: "$TOTAL_DEBIT",
        show: true,
        label: "Saldo devedor total 10 caracteres",
        length: 10,
      },
      {
        name: "$PRINCIPAL_VALUE",
        show: false,
        label: "Valor principal da dívida",
        length: 10,
      },
      { 
        name: "$INTEREST_VALUE",
        show: true,
        label: "Valor dos juros da dívida",
        length: 10 
      },
      {
        name: "$INCASH_DISCOUNT",
        show: false,
        label: "Desconto à vista 3 caracteres",
        length: 3,
      },
      {
        name: "$INSTALLMENT_DISCOUNT",
        show: false,
        label: "Desconto à prazo 3 caracteres",
        length: 3,
      },
      {
        name: "$INSTALLMENT_6_DISCOUNT",
        show: true,
        label: "Desconto parcelado em 6 vezes",
        length: 3,
      },
      {
        name: "$INSTALLMENT_12_DISCOUNT",
        show: true,
        label: "Desconto parcelado em 12 vezes",
        length: 3,
      },
      {
        name: "$INSTALLMENT_24_DISCOUNT",
        show: true,
        label: "Desconto parcelado em 24 vezes",
        length: 3,
      },
      {
        name: "$INCASH_DEBIT_DISCOUNT",
        show: false,
        label: "Desconto á vista (déb. automático)",
        length: 3,
      },
      {
        name: "$INSTALLMENT_DEBIT_6_DISCOUNT",
        show: false,
        label: "Desconto parcelado em 6 vezes (déb. automático)",
        length: 3,
      },
      {
        name: "$INSTALLMENT_DEBIT_12_DISCOUNT",
        show: false,
        label: "Desconto parcelado em 12 vezes (déb. automático)",
        length: 3,
      },
      {
        name: "$INSTALLMENT_DEBIT_24_DISCOUNT",
        show: false,
        label: "Desconto parcelado em 24 vezes (déb. automático)",
        length: 3,
      },
      {
        name: "$INCASH_DEBIT",
        show: false,
        label: "Valor à vista (déb. automático)",
        length: 10,
      },
      { 
        name: "$INCASH",
        show: false,
        label: "Valor à vista", 
        length: 10 
      },
      { 
        name: "$INSTALLMENT_6",
        show: true,
        label: "Valor parcelado em 6 vezes",
        length: 10},
      {
        name: "$INSTALLMENT_12",
        show: true,
        label: "Valor parcelado em 12 vezes",
        length: 10,
      },
      {
        name: "$INSTALLMENT_24",
        show: true,
        label: "Valor parcelado em 24 vezes",
        length: 10,
      },
      {
        name: "$INSTALLMENT_DEBIT_6",
        show: false,
        label: "Valor parcelado em 6 vezes (déb. automático)",
        length: 10,
      },
      {
        name: "$INSTALLMENT_DEBIT_12",
        show: false,
        label: "Valor parcelado em 12 vezes (déb. automático)",
        length: 10,
      },
      {
        name: "$INSTALLMENT_DEBIT_24",
        show: false,
        label: "Valor parcelado em 24 vezes (déb. automático)",
        length: 10,
      },
      {
        name: "$INSTALLMENT_MIN_INTEREST_RATE",
        show: false,
        label: "Menor taxa de juros nas parcelas 6 caracteres",
        length: 6,
      },
      {
        name: "$MIN_INTEREST_RATE_DEBIT",
        show: false,
        label: "Menor taxa de juros (déb. automático)",
        length: 3,
      },
      { 
        name: "$MIN_INTEREST_RATE",
        show: false,
        label: "Menor taxa de juros",
        length: 3 },
      {
        name: "$OPERATIONS_AVG_INTEREST_RATE",
        show: false,
        label: "Taxa média de juros das operações 6 caracteres",
        length: 6,
      },
      {
        name: "$LINK_FOMENTATION",
        show: false,
        label: "Link para fomento 31 caracteres",
        length: 31,
      },
      {
        name: "$LINK",
        show: true,
        label: "Link de negociação 30 caracteres",
        length: 30,
      },
      {
        name: "$GREETING",
        show: true,
        label: "Saudação 9 caracteres",
        length: 9,
      },
      {
        name: "$PASSCODE",
        show: false,
        label: "Código de negociação 4 caracteres",
        length: 4,
      },
      {
        name: "$LINK_ME_LEMBRE",
        show: false,
        label: "Link para me lembre 32 caracteres",
        length: 32,
      },
      {
        name: "$LINK_CREDITOR",
        show: true,
        label: "Link direto p/ credor 33 caracteres",
        length: 33,
      },
      {
        name: "$LINK_REDIRECT",
        show: false,
        label: "Link para redirect 32 caracteres",
        length: 32,
      },
      {
        name: "$CURRENT_DATE",
        show: true,
        label: "Data do dia do disparo no formato DD/MM",
        length: 5,
      },
    ],
  };